import {
  TiptapBase,
  Heading,
  Blockquote,
  BulletList,
  OrderedList,
  Bold,
  Color,
  Italic,
  Strike,
  History,
  FontFamily,
  Link,
  Underline,
  TextAlign,
  HardBreak,
  HorizontalRule,
  ListItem,
  Dropcursor,
  Gapcursor,
  TextStyle,
  Tables,
  Margins,
  PasteFromGoogleDocs,
  UpdateContent,
  AutoSaveContract,
} from '@/js/util/tiptap/extensions';

import {
  BlockquoteHandlers,
  FontFamilyHandlers,
  HeadingLevelHandlers,
  HistoryHandlers,
  HorizontalRuleHandlers,
  LinksHandlers,
  ListsHandlers,
  TableHandlers,
  TextAlignmentHandlers,
  TextColorHandlers,
  TextFormattingHandlers,
  PresetHandlers,
} from '@/js/util/tiptap/handlers';

export default class TextProcessorConfig {
  get extensions() {
    return [
      ...TiptapBase,
      ...Heading,
      ...Blockquote,
      ...BulletList,
      ...OrderedList,
      ...Bold,
      ...Color,
      ...Italic,
      ...Strike,
      ...History,
      ...FontFamily,
      ...Link,
      ...Underline,
      ...TextAlign,
      ...HardBreak,
      ...HorizontalRule,
      ...ListItem,
      ...Dropcursor,
      ...Gapcursor,
      ...TextStyle,
      ...Tables,
      ...Margins,
      ...PasteFromGoogleDocs,
      ...UpdateContent,
      ...AutoSaveContract,
    ];
  }

  get handlers() {
    return {
      ...BlockquoteHandlers,
      ...FontFamilyHandlers,
      ...HeadingLevelHandlers,
      ...HistoryHandlers,
      ...HorizontalRuleHandlers,
      ...LinksHandlers,
      ...ListsHandlers,
      ...TableHandlers,
      ...TextAlignmentHandlers,
      ...TextColorHandlers,
      ...TextFormattingHandlers,
      ...PresetHandlers,
    };
  }
}
